// SessionTimeoutDialog.jsx
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const SessionTimeoutDialog = ({ open, onContinue, onLogout }) => {
  const [timeLeft, setTimeLeft] = useState(5); // 5 saniyelik geri sayım

  useEffect(() => {
    let intervalId;

    if (open) {
      setTimeLeft(60); // Dialog açıldığında süreyi sıfırla

      intervalId = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalId);
            onLogout(); // Süre dolduğunda otomatik çıkış yap
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [open, onLogout]);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent>
        <Typography variant="h6">Oturum Zaman Aşımı</Typography>
        <Typography>
          Uzun süredir işlem yapılmadığı için oturumunuz kapatılacak.
          <br />
          <strong>{timeLeft} saniye</strong> içinde otomatik çıkış yapılacaktır.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="danger">
          Çıkış Yap
        </Button>
        <Button onClick={onContinue} color="primary" variant="outlined" autoFocus>
          Devam Et
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutDialog;